// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* —— Patient — Add appointment drawer (Stitch) —— */
.patient-appointment-drawer.ant-drawer .ant-drawer-content-wrapper {
  width: 520px !important;
  max-width: calc(100vw - 24px);
}

.patient-appointment-drawer .ant-drawer-header {
  display: none;
}

.patient-appointment-drawer .ant-drawer-body {
  padding: 0 !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
}

.patient-appointment-drawer__shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.patient-appointment-drawer__header {
  flex-shrink: 0;
  padding: 20px 24px;
  border-bottom: 1px solid #E2E8F0;
  background: #ffffff;
}

.patient-appointment-drawer__title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.patient-appointment-drawer__title-block {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.patient-appointment-drawer__title-copy {
  min-width: 0;
}

.patient-appointment-drawer__title-line {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.patient-appointment-drawer__title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #0F172A;
  line-height: 1.3;
}

.patient-appointment-drawer__badge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.patient-appointment-drawer__subtitle {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.4;
  color: #64748B;
}

.patient-appointment-drawer__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #64748B;
  cursor: pointer;
  flex-shrink: 0;
}

.patient-appointment-drawer__icon-btn--bordered {
  border: 1px solid #E2E8F0;
  background: #ffffff;
}

.patient-appointment-drawer__icon-btn:hover {
  background: #F1F5F9;
  color: #0F172A;
}

[dir='rtl'] .patient-appointment-drawer__title-block > .patient-appointment-drawer__icon-btn .anticon {
  transform: scaleX(-1);
}

.patient-appointment-drawer__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  background: #ffffff;
}

.patient-appointment-drawer__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.patient-appointment-drawer__label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
}

.patient-appointment-drawer__req {
  color: #F43F5E;
}

.patient-appointment-drawer__control {
  position: relative;
}

.patient-appointment-drawer__control-icon {
  position: absolute;
  inset-inline-start: 12px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  color: #94A3B8;
  font-size: 16px;
  pointer-events: none;
}

.patient-appointment-drawer__select.ant-select,
.patient-appointment-drawer__picker.ant-picker {
  width: 100%;
}

.patient-appointment-drawer__select .ant-select-selector,
.patient-appointment-drawer__picker.ant-picker {
  height: 36px !important;
  border-radius: 8px !important;
  border-color: #E2E8F0 !important;
  padding-inline-start: 36px !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.patient-appointment-drawer__select .ant-select-selection-item,
.patient-appointment-drawer__select .ant-select-selection-placeholder,
.patient-appointment-drawer__picker .ant-picker-input > input {
  font-size: 12px !important;
  font-weight: 500;
  line-height: 34px !important;
}

.patient-appointment-drawer__select.ant-select-focused .ant-select-selector,
.patient-appointment-drawer__picker.ant-picker-focused {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;
}

.patient-appointment-drawer__picker .ant-picker-suffix {
  color: transparent;
}

.patient-appointment-drawer__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

@media (max-width: 520px) {
  .patient-appointment-drawer__row {
    grid-template-columns: 1fr;
  }
}

.patient-appointment-drawer__package {
  padding: 14px;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.patient-appointment-drawer__package-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.patient-appointment-drawer__package-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #0F172A;
  cursor: pointer;
}

.patient-appointment-drawer__package-toggle input {
  width: 16px;
  height: 16px;
  accent-color: #0EA5E9;
}

.patient-appointment-drawer__package-count {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 9999px;
  border: 1px solid #A7F3D0;
  background: #ECFDF5;
  color: #047857;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.patient-appointment-drawer__package-empty {
  font-size: 12px;
  color: #94A3B8;
  padding: 8px 0;
}

.patient-appointment-drawer__package-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.patient-appointment-drawer__package-selected {
  font-size: 12px;
  font-weight: 600;
  color: #0284c7;
}

.patient-appointment-drawer__package-card {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  text-align: start;
  font-family: inherit;
  cursor: pointer;
}

.patient-appointment-drawer__package-card.is-selected {
  border-color: #0EA5E9;
  box-shadow: 0 0 0 1px rgba(14, 165, 233, 0.15);
}

.patient-appointment-drawer__package-main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  color: #0EA5E9;
}

.patient-appointment-drawer__package-name {
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
}

.patient-appointment-drawer__package-meta {
  margin-top: 2px;
  font-size: 11px;
  color: #64748B;
  font-variant-numeric: tabular-nums;
}

.patient-appointment-drawer__package-check {
  color: #059669;
  font-size: 18px;
  flex-shrink: 0;
}

.patient-appointment-drawer__textarea.ant-input {
  border-radius: 8px !important;
  border-color: #E2E8F0 !important;
  font-size: 12px !important;
  padding: 10px 12px !important;
  resize: none;
  box-shadow: none !important;
}

.patient-appointment-drawer__textarea.ant-input:focus {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;
}

.patient-appointment-drawer__footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #E2E8F0;
  background: #ffffff;
}

.patient-appointment-drawer__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}

.patient-appointment-drawer__btn--ghost {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #334155;
}

.patient-appointment-drawer__btn--ghost:hover {
  background: #F8FAFC;
  color: #0F172A;
}

.patient-appointment-drawer__btn--primary {
  border: 0;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.patient-appointment-drawer__btn--primary:hover:not(:disabled) {
  background: #0284C7;
}

.patient-appointment-drawer__btn--primary:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShowPatient/components/drawers/AddAppointmentDrawer.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,qCAAqC;EACrC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;;EAGE,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,0BAA0B;EAC1B,6BAA6B;EAC7B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["/* —— Patient — Add appointment drawer (Stitch) —— */\n.patient-appointment-drawer.ant-drawer .ant-drawer-content-wrapper {\n  width: 520px !important;\n  max-width: calc(100vw - 24px);\n}\n\n.patient-appointment-drawer .ant-drawer-header {\n  display: none;\n}\n\n.patient-appointment-drawer .ant-drawer-body {\n  padding: 0 !important;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.patient-appointment-drawer__shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.patient-appointment-drawer__header {\n  flex-shrink: 0;\n  padding: 20px 24px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.patient-appointment-drawer__title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.patient-appointment-drawer__title-block {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.patient-appointment-drawer__title-copy {\n  min-width: 0;\n}\n\n.patient-appointment-drawer__title-line {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.patient-appointment-drawer__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.patient-appointment-drawer__badge {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.patient-appointment-drawer__subtitle {\n  margin: 4px 0 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #64748B;\n}\n\n.patient-appointment-drawer__icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748B;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.patient-appointment-drawer__icon-btn--bordered {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.patient-appointment-drawer__icon-btn:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n[dir='rtl'] .patient-appointment-drawer__title-block > .patient-appointment-drawer__icon-btn .anticon {\n  transform: scaleX(-1);\n}\n\n.patient-appointment-drawer__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  background: #ffffff;\n}\n\n.patient-appointment-drawer__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.patient-appointment-drawer__label {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #334155;\n}\n\n.patient-appointment-drawer__req {\n  color: #F43F5E;\n}\n\n.patient-appointment-drawer__control {\n  position: relative;\n}\n\n.patient-appointment-drawer__control-icon {\n  position: absolute;\n  inset-inline-start: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n  color: #94A3B8;\n  font-size: 16px;\n  pointer-events: none;\n}\n\n.patient-appointment-drawer__select.ant-select,\n.patient-appointment-drawer__picker.ant-picker {\n  width: 100%;\n}\n\n.patient-appointment-drawer__select .ant-select-selector,\n.patient-appointment-drawer__picker.ant-picker {\n  height: 36px !important;\n  border-radius: 8px !important;\n  border-color: #E2E8F0 !important;\n  padding-inline-start: 36px !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.patient-appointment-drawer__select .ant-select-selection-item,\n.patient-appointment-drawer__select .ant-select-selection-placeholder,\n.patient-appointment-drawer__picker .ant-picker-input > input {\n  font-size: 12px !important;\n  font-weight: 500;\n  line-height: 34px !important;\n}\n\n.patient-appointment-drawer__select.ant-select-focused .ant-select-selector,\n.patient-appointment-drawer__picker.ant-picker-focused {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;\n}\n\n.patient-appointment-drawer__picker .ant-picker-suffix {\n  color: transparent;\n}\n\n.patient-appointment-drawer__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n@media (max-width: 520px) {\n  .patient-appointment-drawer__row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.patient-appointment-drawer__package {\n  padding: 14px;\n  border-radius: 12px;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.patient-appointment-drawer__package-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.patient-appointment-drawer__package-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0F172A;\n  cursor: pointer;\n}\n\n.patient-appointment-drawer__package-toggle input {\n  width: 16px;\n  height: 16px;\n  accent-color: #0EA5E9;\n}\n\n.patient-appointment-drawer__package-count {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 9999px;\n  border: 1px solid #A7F3D0;\n  background: #ECFDF5;\n  color: #047857;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.patient-appointment-drawer__package-empty {\n  font-size: 12px;\n  color: #94A3B8;\n  padding: 8px 0;\n}\n\n.patient-appointment-drawer__package-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.patient-appointment-drawer__package-selected {\n  font-size: 12px;\n  font-weight: 600;\n  color: #0284c7;\n}\n\n.patient-appointment-drawer__package-card {\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  text-align: start;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.patient-appointment-drawer__package-card.is-selected {\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 1px rgba(14, 165, 233, 0.15);\n}\n\n.patient-appointment-drawer__package-main {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  color: #0EA5E9;\n}\n\n.patient-appointment-drawer__package-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.patient-appointment-drawer__package-meta {\n  margin-top: 2px;\n  font-size: 11px;\n  color: #64748B;\n  font-variant-numeric: tabular-nums;\n}\n\n.patient-appointment-drawer__package-check {\n  color: #059669;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.patient-appointment-drawer__textarea.ant-input {\n  border-radius: 8px !important;\n  border-color: #E2E8F0 !important;\n  font-size: 12px !important;\n  padding: 10px 12px !important;\n  resize: none;\n  box-shadow: none !important;\n}\n\n.patient-appointment-drawer__textarea.ant-input:focus {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;\n}\n\n.patient-appointment-drawer__footer {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.patient-appointment-drawer__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;\n}\n\n.patient-appointment-drawer__btn--ghost {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n}\n\n.patient-appointment-drawer__btn--ghost:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n.patient-appointment-drawer__btn--primary {\n  border: 0;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.patient-appointment-drawer__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n}\n\n.patient-appointment-drawer__btn--primary:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
